<template>
  <div class="jf-window job-orders">
    <a href="javascript:;" class="toggle open" @click="$emit('close')">ORDERS</a>
    <a href="javascript:;" class="plus" v-tooltip="'Add order'" @click="showModalAdd = true">+</a>
    <ul v-if="JOB_ORDERS.length">
      <li v-for="(order, index) in JOB_ORDERS" :key="index">
        <div class="details">
          <div class="no">#{{ order.order_number }}</div>
          <div class="name">
            <router-link :to="{name: 'order', params: {orderId: order.id}}" class="black">{{ order.name }}</router-link>
          </div>
          <span class="status" :class="order.status">{{ order.status | statusToUCWords }}</span>
        </div>
        <div class="actions">
          <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate order'" @click="confDuplicate(index)"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Delete order'" @click="confDelete(index)"></a>
        </div>
      </li>
    </ul>
    <div v-if="totalAmount" class="tt">
      TOTAL ORDERS: ${{ totalAmount | numberFormat }}
    </div>
    <modal-add-order v-model="showModalAdd" :job="JOB" @added="onAdded"></modal-add-order>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ServiceOrder from '@/services/order'
  import ModalAddOrder from '@/components/orders/ModalAddOrder'
  import ModalDuplicate from '@/components/orders/ModalDuplicate'

  export default {
    components: {
      ModalAddOrder,
    },
    data() {
      return {
        showModalAdd: false
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['JOB', 'JOB_ORDERS']),
      totalAmount: function () {
        let self = this, total = 0;
        for (var i in self.JOB_ORDERS) {
          total += self.JOB_ORDERS[i].total_value;
        }
        return total;
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
      },
      onAdded(order) {
        this.$store.dispatch('ADD_JOB_ORDER', order);
      },
      confDuplicate ( index ) {
        let self = this;
        self.JOB_ORDERS[index].client = self.JOB.client;
        self.$modal.show(ModalDuplicate, {
          index: index,
          order: self.JOB_ORDERS[index],
          on_job_view: true
        }, {
          clickToClose: false,
          width: 592
        });
      },
      confDelete(index) {
        let self = this, item = self.JOB_ORDERS[index];
        self.$dialog
          .confirm('Are you sure you want to delete order #<strong>' + item.id + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceOrder.delete(item.id, () => {
              dialog.close();
              self.JOB_ORDERS.splice(index, 1);
              self.$notify({
                type: 'success',
                text: 'Order <strong>' + item.name + '</strong> has been deleted'
              });
              self.$store.dispatch('GET_JOB', self.JOB.id);
            });
          })
          .catch(() => {
          })
        ;
      },
    }
  }
</script>
